import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ErrorMessage,
  Field,
  FieldArray,
  Form,
  Formik,
  isEmptyArray,
} from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Form as BootstrapForm, Button, Table } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import Modal from "react-bootstrap/Modal";
import { BiDownload } from "react-icons/bi";
import { FiEdit2 } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import "react-image-crop/dist/ReactCrop.css";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import Swal from "sweetalert2";
import * as Yup from "yup";
import userImage from "../../../assets/images/user.webp";
import NavbarComponent from "../../../components/Navbar";
import CustomProfileModal from "../../../components/common/CustomProfileModal";
import {
  applyResumeByJobSeeker,
  getCityState,
  getJobSeeker,
  jobSeekerImageUpdate,
  jobSeekerProfileUpdate,
} from "../../../helpers/backendHelper";
import * as url from "../../../helpers/urlHelper";
import "../../../styles/Myprofile.css";
import { FaDeleteLeft } from "react-icons/fa6";
import { format } from "date-fns";
import { RxCross2 } from "react-icons/rx";
import { PiCheckCircleLight } from "react-icons/pi";
import { PiXCircleLight } from "react-icons/pi";

const cities = [
  "New York, NY",
  "Los Angeles, CA",
  "Chicago, IL",
  "Houston, TX",
  "Phoenix, AZ",
  "Philadelphia, PA",
  "San Antonio, TX",
  "San Diego, CA",
  "Dallas, TX",
  "San Jose, CA",
];

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  mobileNumber: Yup.string()
    .required("Mobile number is required")
    .matches(/^\d+$/, "Mobile number must contain only digits")
    .length(10, "Mobile number must be exactly 10 digits"),
  cityState: Yup.string().required("City State is required"),
  country: Yup.string().required("Country is required"),
  pinCode: Yup.string()
    .matches(
      /^[0-9]{5,10}$/,
      "Pin Code must be a valid number with 5-10 digits"
    )
    .required("Pin Code is required"),
  address: Yup.string()
    .min(5, "Address must be at least 5 characters long")
    .max(255, "Address cannot exceed 255 characters")
    .required("Address is required"),
  about: Yup.string().nullable().max(500, "Maximum 500 characters allowed"),
  lastName: Yup.string().required("Last Name is required"),
  jobseekerStatus: Yup.string().required("Jobseeker Status is required"),
  jobseekerTitle: Yup.string().required("Jobseeker title is required"),
});

const validationSchemaDetails = Yup.object().shape({
  gender: Yup.string().required("Gender is required"),
  maritalStatus: Yup.string().required("Marital status is required"),
  dateOfBirth: Yup.date()
    .required("Date of birth is required")
    .max(
      new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
      "You must be at least 18 years old"
    ),
  url: Yup.string().url("Enter a valid URL"),
});

const validationSchemaDetails2 = Yup.object().shape({
  educations: Yup.array().of(
    Yup.object().shape({
      degree: Yup.string().nullable(),
      institution: Yup.string().nullable(),
      startDate: Yup.date()
        .nullable()
        .typeError("Invalid date format")
        .max(Yup.ref("endDate"), "Start date must be before finish date"),
      endDate: Yup.date()
        .nullable()
        .typeError("Invalid date format")
        .test(
          "is-valid-end-date",
          "Finish date must be after start date",
          function (value) {
            const { startDate } = this.parent;
            if (startDate && value && new Date(value) < new Date(startDate)) {
              return false;
            }
            return true;
          }
        ),
      description: Yup.string().nullable(),
    })
  ),
  languages: Yup.array().of(
    Yup.object().shape({
      languageTitle: Yup.string(),
      expertLevel: Yup.string(),
      skills: Yup.array().of(Yup.string()).nullable(),
    })
  ),
  careerBreak: Yup.array().of(
    Yup.object().shape({
      reason: Yup.string().max(255, "Reason cannot exceed 255 characters"),
      startDate: Yup.date()
        .nullable()
        .typeError("Invalid date format")
        .max(new Date(), "Start date cannot be in the future"),
      endDate: Yup.date()
        .typeError("Invalid date format")
        .min(Yup.ref("startDate"), "End date must be after start date")
        .max(new Date(), "End date cannot be in the future")
        .nullable(),
    })
  ),
});

const validationSchemaSkills = Yup.object().shape({
  skillName: Yup.string(),
  proficiency: Yup.string(),
  certificates: Yup.array().of(
    Yup.object({
      name: Yup.string(),
      issueDate: Yup.date()
        .nullable()
        .max(new Date(), "Issue Date cannot be in the future"),
    })
  ),
});

const validationSchemaExperiance = Yup.object().shape({
  experiances: Yup.array().of(
    Yup.object({
      companyName: Yup.string().required("company name is required"),
      jobTitle: Yup.string().required("job title is required"),
      summary: Yup.string()
        .max(255, "summary cannot exceed 255 characters")
        .required("summary is required"),
      duration: Yup.string().required("duration is required"),
    })
  ),
});

const JobSeekerProfile = () => {
  const formik1Ref = useRef();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [dummyImage, setDummyImage] = useState(userImage);
  const [userData, setUserData] = useState({
    firstName: "",
    email: "",
    mobileNumber: "",
    country: "",
    location: {
      address: "",
      cityState: "",
      pinCode: "",
    },
    about: "",
    lastName: "",
    userType: "",
    jobseekerTitle: "",
    skills: [],
    certificates: [
      {
        name: "",
        issueDate: "",
      },
    ],
    gender: "",
    maritalStatus: "",
    dateOfBirth: "",
    url: "",
    careerBreak: [],
    educations: [],
    languages: [],
    experiences: [
      {
        company: "",
        jobTitle: "",
        startDate: "",
        endDate: "",
      },
    ],
    isProfileUpdate: false,
    jobSeekerProfileImage: userImage,
    jobSeekerCoverImage: userImage,
  });
  const [editMode, setEditMode] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [isTwoFAEnabled, setIsTwoFAEnabled] = useState(false);
  const [isSetup2Fa, setIsSetup2Fa] = useState(false);
  const [allCityState, setAllCityState] = useState([]);
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [editableImage, setEditableImage] = useState();

  const [showPopup, setShowPopup] = useState(false);
  const [editTab, setEditTab] = useState("");
  const [fileName, setFileName] = useState("");
  const [skillError, setSkillError] = useState("");

  useEffect(() => {
    fetchUserData();
  }, [editMode]);

  useEffect(() => {
    fetchCityState();
  }, []);

  useEffect(() => {
    if (skillError !== "") {
      const skillErrorTimeOut = setTimeout(() => {
        setSkillError("");
      }, 10000);
      return () => clearTimeout(skillErrorTimeOut);
    }
  }, [skillError]);

  const fetchCityState = async () => {
    try {
      const response = await getCityState();
      if (response && response.statusCode === 200) {
        const data = response.cities;
        setAllCityState(data);
      }
    } catch (error) {
      console.error("Error fetching city/state data:", error);
    }
  };

  const updateAvatar = async (imgSrc) => {
    const base64ToFile = (base64String, fileName) => {
      const arr = base64String.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    };

    const formData = new FormData();
    const file = base64ToFile(imgSrc, `${editableImage}.png`);
    formData.append(editableImage, file);

    try {
      await jobSeekerImageUpdate(formData);
      fetchUserData();
    } catch (error) {
      console.error("Error updating avatar:", error);
    }
  };

  const fetchUserData = async () => {
    try {
      const response = await getJobSeeker();
      if (response && response.statusCode === 200) {
        const data = response.jobseeker;
        setUserData(data);
        console.log("userdata.....", data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleChangeTwoFA = () => {
    setIsSetup2Fa(!isSetup2Fa);
  };

  const handleClose2Fa = () => {
    setIsSetup2Fa(false);
  };

  const handleCombinedSubmit = async (formik1Values, formik2Values) => {
    console.log("values of profile", formik1Values, formik2Values);

    const combinedValues = { ...formik1Values, ...formik2Values };

    const payload = {
      ...(userData.isEmailUser === false && {
        email: combinedValues.email || "",
      }),
      ...(userData.isMobileNumberUser === false && {
        mobileNumber: combinedValues.mobileNumber || "",
      }),
      firstName: combinedValues.firstName,
      location: {
        address: combinedValues.address,
        cityState: combinedValues.cityState,
        pinCode: combinedValues.pinCode,
      },
      country: combinedValues.country,
      about: combinedValues.about,
      lastName: combinedValues.lastName,
      status: combinedValues.jobseekerStatus,
      jobseekerTitle: combinedValues.jobseekerTitle,
      isProfileUpdate: true,
    };

    try {
      console.log("payload", payload);
      const updateData = await jobSeekerProfileUpdate(payload);
      console.log("updateData", updateData);
      if (updateData && updateData.statusCode === 200) {
        fetchUserData();
        localStorage.setItem("isProfileUpdated", "true");
        Swal.fire("Updated!", "Profile updated successfully", "success");
        // navigate('/jobs');
      }
      setEditMode(false);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleSubmitResume = async (values, { setSubmitting, resetForm }) => {
    console.log("values of resume", values);

    const formData = new FormData();
    formData.append("resume", values.jobSeekerResume);

    try {
      const respone = await applyResumeByJobSeeker(formData);
      if (respone && respone.statusCode === 200) {
        Swal.fire("Updated!", "Resume updated successfully", "success");
        fetchUserData();
        setFileName("");
      }
    } catch (error) {
      console.log("Resume cannot upload", error);
    }
    setSubmitting(false);
  };

  const handleAddSkill = async (values, setFieldValue, resetForm) => {
    console.log("values of skills", values);
    if (values.skillName !== "") {
      setSkillError("");
      const skillPayload = {
        skills: [
          {
            name: values.skillName,
            proficiency: values.proficiency,
          },
        ],
      };
      const response = await jobSeekerProfileUpdate(skillPayload);
      if (response && response.statusCode === 200) {
        fetchUserData();
        resetForm();
        setFieldValue("skillName", "");
        setFieldValue("proficiency", "Beginner");
      }
    } else {
      setSkillError("Skill name cannot be empty.");
    }
  };

  const handleSubmitForm = async (values) => {
    const payload = {
      certificates: values.certificates,
    };
    const response = await jobSeekerProfileUpdate(payload);
    if (response && response.statusCode === 200) {
      fetchUserData();
      setShowPopup(false);
      Swal.fire("Updated!", "Skills updated successfully", "success");
    }
  };

  const handleSubmitDetail = async (values) => {
    console.log("values of detail", values);
    const payload = {
      gender: values.gender,
      maritalStatus: values.maritalStatus,
      dateOfBirth: values.dateOfBirth,
      url: values.url,
    };
    console.log("payload of detail", payload);

    const updateDetail = await jobSeekerProfileUpdate(payload);
    if (updateDetail && updateDetail.statusCode === 200) {
      fetchUserData();
      setShowPopup(false);
      Swal.fire("Updated!", "Personal details updated successfully", "success");
    }
  };

  const handleSubmitDetail2 = async (values) => {
    console.log("values of detail", values);
    const payload = {
      // gender: values.gender,
      // maritalStatus: values.maritalStatus,
      // dateOfBirth: values.dateOfBirth,
      // url: values.url,
      ...(values.educations &&
        values.educations.length > 0 && {
          educations: values.educations.filter((education) =>
            Object.values(education).some((value) => value !== "")
          ),
        }),
      ...(values.languages &&
        values.languages.length > 0 && {
          languages: values.languages.filter(
            (language) =>
              language.languageTitle !== "" || language.expertLevel !== ""
          ),
        }),
      ...(values.careerBreak &&
        values.careerBreak.length > 0 && {
          careerBreaks: values.careerBreak.filter((career) =>
            Object.values(career).some((value) => value !== "")
          ),
        }),
    };
    console.log("payload of detail", payload);

    const updateDetail = await jobSeekerProfileUpdate(payload);
    if (updateDetail && updateDetail.statusCode === 200) {
      fetchUserData();
      setShowPopup(false);
      Swal.fire("Updated!", "Personal details updated successfully", "success");
    }
  };

  const handleSubmitExperiance = async (values) => {
    console.log("values", values);
    const payload = {
      experiences: values.experiances,
    };
    const updateData = await jobSeekerProfileUpdate(payload);
    if (updateData && updateData.statusCode === 200) {
      fetchUserData();
      setShowPopup(false);
      Swal.fire("Updated!", "Experiences updated successfully", "success");
    }
  };

  const handleDeleteField = async (field, delId) => {
    let deletePayload = {};

    if (field === "skill") {
      deletePayload = {
        deleteSkills: [delId],
      };
    } else if (field === "certificates") {
      deletePayload = {
        deleteCertificates: [delId],
      };
    } else if (field === "careerBreaks") {
      deletePayload = {
        deleteCareerBreaks: [delId],
      };
    } else if (field === "educations") {
      deletePayload = {
        deleteEducations: [delId],
      };
    } else if (field === "languages") {
      deletePayload = {
        deleteLanguages: [delId],
      };
    } else if (field === "experiences") {
      deletePayload = {
        deleteExperiences: [delId],
      };
    }

    console.log(deletePayload);
    const response = await jobSeekerProfileUpdate(deletePayload);
    if (response && response.statusCode === 200) {
      fetchUserData();
    }
  };

  const downloadFile = async (url, fileName = "resume.pdf") => {
    if (!url) {
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "No file URL found.",
      });
      return;
    }

    fetch(url, { method: "GET" })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch file.");
        return response.blob();
      })
      .then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Download Error",
          text: "Unable to download the resume. Please try again.",
        });
        console.error("Error downloading file:", error);
      });
  };

  const handleCamaraClick = (value) => {
    setEditableImage(value);
    setModalOpen(true);
  };

  const getSuggestions = (inputValue) => {
    return allCityState.filter((city) =>
      city.toLowerCase().includes(inputValue.trim().toLowerCase())
    );
  };

  const handleEditTab = (tabEdit) => {
    if (tabEdit === "skills") {
      setEditTab(tabEdit);
    } else if (tabEdit === "personalDetail") {
      setEditTab(tabEdit);
    } else if (tabEdit === "personalDetail2") {
      setEditTab(tabEdit);
    } else if (tabEdit === "experiance") {
      setEditTab(tabEdit);
    }
    setShowPopup(true);
  };

  const optionsJobSeekerType = [
    { value: "Searching for jobs", label: "Searching for jobs" },
    { value: "casually exploring jobs", label: "casually exploring jobs" },
    { value: "Received a job offer", label: "Received a job offer" },
    { value: "Not looking for jobs", label: "Not looking for jobs" },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "3px",
      borderRadius: "20px",
      borderColor: "#d9d9d9",
      boxShadow: "none",
      "&:hover": { borderColor: "#b3b3b3" },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#717B9E",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
    }),
  };

  return (
    <>
      <NavbarComponent />
      <Container className="mt-lg-4 mt-3">
        <Row>
          {modalOpen && (
            <CustomProfileModal
              updateAvatar={updateAvatar}
              closeModal={() => setModalOpen(false)}
              showModal={modalOpen}
              editableImage={editableImage}
            />
          )}
          <Col lg={6}>
            <Card className="bg-white border-0 profile-left-card box-shadow-profile">
              <div className="background-container">
                <Image
                  src={
                    userData.jobSeekerCoverImage === "null"
                      ? dummyImage
                      : `${url.IMAGE_HOST_URL}${userData.jobSeekerCoverImage}`
                  }
                  className="background-image"
                />
                <div className="profile-container">
                  <Image
                    src={
                      userData.jobSeekerProfileImage === "null"
                        ? dummyImage
                        : `${url.IMAGE_HOST_URL}${userData.jobSeekerProfileImage}`
                    }
                    className="profile-image"
                  />
                  <FontAwesomeIcon
                    icon={faCamera}
                    size="lg"
                    className="camera-icon"
                    onClick={() => handleCamaraClick("profileImage")}
                  />
                </div>
                <FontAwesomeIcon
                  icon={faCamera}
                  size="lg"
                  className="background-camera"
                  onClick={() => handleCamaraClick("coverImage")}
                />
              </div>

              <div className="text-center mt-5">
                <h5 className="mt-sm-3">
                  {userData.firstName} {userData.lastName}
                </h5>
                {userData?.location?.cityState !== "" &&
                userData?.country !== "" ? (
                  <p className="text-muted">
                    {userData?.location?.cityState}
                    {userData?.country ? `, ${userData.country}` : null}
                  </p>
                ) : null}
              </div>

              <div className="p-3">
                <strong className="fs-5">Info</strong>
                {!editMode ? (
                  <p className="text-justify mt-2">
                    {userData?.about?.trim()
                      ? userData.about
                      : `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                                                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                                                sunt in culpa qui officia deserunt mollit anim id est laborum.`}
                  </p>
                ) : (
                  <Formik
                    innerRef={formik1Ref}
                    initialValues={{
                      about: userData?.about || "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                      console.log("Formik 1 values:", values);
                    }}
                    enableReinitialize
                  >
                    <Form>
                      <Row className="mt-2">
                        <Col xs={12}>
                          <Field
                            as="textarea"
                            name="about"
                            id="about"
                            rows="6"
                            className="form-control"
                            placeholder="Enter a brief summary of the job"
                          />
                          <ErrorMessage
                            name="about"
                            component="div"
                            className="mt-2 text-danger"
                          />
                        </Col>
                      </Row>
                    </Form>
                  </Formik>
                )}
              </div>
            </Card>
          </Col>
          <Col className="mt-4 mt-lg-0" lg={6}>
            <Card className="border-0 bg-white box-shadow-profile">
              <CardHeader className="p-0">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={
                        activeTab === "1" ? "active cursor-pointer" : "tab-head"
                      }
                      onClick={() => toggleTab("1")}
                    >
                      Profile
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={
                        activeTab === "2" ? "active cursor-pointer" : "tab-head"
                      }
                      onClick={() => toggleTab("2")}
                    >
                      Personal details
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={
                        activeTab === "3" ? "active cursor-pointer" : "tab-head"
                      }
                      onClick={() => toggleTab("3")}
                    >
                      Skills
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={
                        activeTab === "4" ? "active cursor-pointer" : "tab-head"
                      }
                      onClick={() => toggleTab("4")}
                    >
                      Resume
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={
                        activeTab === "5" ? "active cursor-pointer" : "tab-head"
                      }
                      onClick={() => toggleTab("5")}
                    >
                      Experiance
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody className="card-div">
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Formik
                      initialValues={{
                        firstName: userData.firstName,
                        email: userData.email,
                        mobileNumber: userData.mobileNumber,
                        cityState: userData?.location?.cityState || "",
                        pinCode: userData?.location?.pinCode || "",
                        address: userData?.location?.address || "",
                        country: userData.country,
                        lastName: userData.lastName,
                        jobseekerStatus: userData.jobseekerStatus,
                        jobseekerTitle: userData.jobseekerTitle,
                      }}
                      validationSchema={validationSchema}
                      // onSubmit={handleSave}
                      onSubmit={(formik2Values) => {
                        const formik1Values = formik1Ref.current?.values || {};
                        handleCombinedSubmit(formik1Values, formik2Values);
                      }}
                      enableReinitialize
                    >
                      {({ values, setFieldValue, handleSubmit }) => (
                        <Form>
                          <Row>
                            <Col xs={12} className="d-flex justify-content-end">
                              <FiEdit2
                                className="cursor-pointer edit-btn-profile my-2 me-2"
                                onClick={()=>setEditMode(!editMode)}
                              />
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="firstName">First Name</Label>
                                <Field
                                  type="text"
                                  name="firstName"
                                  id="firstName"
                                  className="form-control"
                                  disabled={!editMode}
                                  placeholder="Enter First name"
                                />
                                <ErrorMessage
                                  name="firstName"
                                  component="div"
                                  className="text-danger error-text"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="firstName">Last Name</Label>
                                <Field
                                  type="text"
                                  name="lastName"
                                  id="lastName"
                                  className="form-control"
                                  disabled={!editMode}
                                  placeholder="Enter Last name"
                                />
                                <ErrorMessage
                                  name="lastName"
                                  component="div"
                                  className="text-danger error-text"
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row className="mt-2">
                            <Col md={6}>
                              <FormGroup>
                                <Label for="country">Country</Label>
                                <Field
                                  type="text"
                                  name="country"
                                  id="country"
                                  className="form-control"
                                  disabled={!editMode}
                                  placeholder="Enter Country"
                                />
                                <ErrorMessage
                                  name="country"
                                  component="div"
                                  className="text-danger error-text"
                                />
                              </FormGroup>
                            </Col>
                            {/* <Col md={6}>
                                                            <FormGroup>
                                                                <Label for="cityState">City & State</Label>

                                                                <select
                                                                    id="cityState"
                                                                    name="cityState"
                                                                    className="form-control"
                                                                    // onChange={(e) => formik.setFieldValue('cityState', e.target.value)}
                                                                    // value={formik.values.cityState}
                                                                    onChange={(e) => setFieldValue('cityState', e.target.value)} // Using Formik's setFieldValue to update the form state
                                                                    value={values.cityState || ''}
                                                                    disabled={!editMode}
                                                                >
                                                                    <option value="">Select a city</option>
                                                                    {allCityState.map((cityObj) => (
                                                                        <option key={cityObj._id} value={`${cityObj.city}, ${cityObj.state}`}>
                                                                            {cityObj.city}, {cityObj.state}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </FormGroup>
                                                        </Col> */}
                            <Col md={6}>
                              <FormGroup>
                                <Label for="cityState">City & State</Label>
                                <Field
                                  as="select"
                                  name="cityState"
                                  className="form-control"
                                  disabled={!editMode}
                                >
                                  <option value="">Select a city</option>
                                  {allCityState?.length > 0 &&
                                    allCityState.map((cityObj) => (
                                      <option
                                        key={cityObj._id}
                                        value={`${cityObj.city}, ${cityObj.state}`}
                                      >
                                        {cityObj.city}, {cityObj.state}
                                      </option>
                                    ))}
                                </Field>
                                <ErrorMessage
                                  name="cityState"
                                  component="div"
                                  className="text-danger error-text"
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={6} className="mt-2">
                              <BootstrapForm.Group controlId="address">
                                <BootstrapForm.Label>
                                  Address
                                </BootstrapForm.Label>
                                <Field
                                  type="text"
                                  name="address"
                                  className="form-control"
                                  placeholder="Enter your address"
                                  disabled={!editMode}
                                />
                                <ErrorMessage
                                  name="address"
                                  component="div"
                                  className="text-danger error-text"
                                />
                              </BootstrapForm.Group>
                            </Col>
                            <Col md={6} className="mt-2">
                              <FormGroup>
                                <Label for="pinCode">Pincode</Label>
                                <Field
                                  type="text"
                                  name="pinCode"
                                  id="pinCode"
                                  className="form-control"
                                  disabled={!editMode}
                                  placeholder="Enter pincode"
                                />
                                <ErrorMessage
                                  name="pinCode"
                                  component="div"
                                  className="text-danger error-text"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <FormGroup>
                                <Label for="email">Email</Label>
                                <Field
                                  type="email"
                                  name="email"
                                  id="email"
                                  className="form-control"
                                  disabled={userData.isEmailUser || !editMode}
                                  placeholder="Enter Email"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="text-danger error-text"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <FormGroup>
                                <Label for="mobileNumber">Phone</Label>
                                <Field
                                  type="text"
                                  name="mobileNumber"
                                  id="mobileNumber"
                                  className="form-control"
                                  disabled={
                                    userData.isMobileNumberUser || !editMode
                                  }
                                  placeholder="Enter phone"
                                />
                                <ErrorMessage
                                  name="mobileNumber"
                                  component="div"
                                  className="text-danger error-text"
                                />
                              </FormGroup>
                            </Col>
                            {/* <Col md={6} className="mt-2">
                                                            <FormGroup>
                                                                <Label for="userType">User Type</Label>
                                                                <Field
                                                                    type="text"
                                                                    name="userType"
                                                                    id="userType"
                                                                    className="form-control"
                                                                    disabled
                                                                />
                                                                <ErrorMessage name="userType" component="div" className="text-danger" />
                                                            </FormGroup>
                                                        </Col> */}

                            <Col md={6} className="mt-2">
                              <FormGroup>
                                <Label for="jobseekerStatus">
                                  JobSeeker Status
                                </Label>
                                <BootstrapForm.Group
                                  className="mb-2"
                                  controlId="formBasicEmail"
                                >
                                  <Select
                                    name="jobseekerStatus"
                                    id="jobseekerStatus"
                                    className="w-100"
                                    isDisabled={!editMode}
                                    value={
                                      values.jobseekerStatus
                                        ? {
                                            values: values.jobseekerStatus,
                                            label:
                                              values.jobseekerStatus
                                                .charAt(0)
                                                .toUpperCase() +
                                              values.jobseekerStatus.slice(1),
                                          }
                                        : null
                                    }
                                    onChange={(selectedOption) =>
                                      setFieldValue(
                                        "jobseekerStatus",
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      )
                                    }
                                    options={optionsJobSeekerType}
                                    isSearchable={false}
                                    isClearable
                                    components={{
                                      IndicatorSeparator: () => null,
                                    }}
                                    styles={{
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isDisabled
                                          ? "#e9ecef"
                                          : "white",
                                        border: "1px solid #dee2e6",
                                        borderRadius: "5px",
                                        color: state.isDisabled
                                          ? "#000000"
                                          : "#000000",
                                      }),
                                      singleValue: (provided, state) => ({
                                        ...provided,
                                        color: state.isDisabled
                                          ? "#000"
                                          : "#000",
                                      }),
                                    }}
                                  />
                                </BootstrapForm.Group>
                                <ErrorMessage
                                  name="jobseekerStatus"
                                  component="div"
                                  className="text-danger error-text"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6} className="mt-2">
                              <FormGroup>
                                <Label for="jobDesignation">
                                  JobSeeker Title
                                </Label>
                                <Field
                                  type="text"
                                  name="jobseekerTitle"
                                  id="jobseekerTitle"
                                  className="form-control"
                                  placeholder="Enter jobseeker title"
                                  disabled={!editMode}
                                />
                                <ErrorMessage
                                  name="jobseekerTitle"
                                  component="div"
                                  className="text-danger"
                                />
                              </FormGroup>
                            </Col>
                            <Col xs={12} className="d-flex justify-content-end">
                                <Button
                                    className="edit-btn mt-4"
                                    type="submit"
                                    onClick={(e) => {
                                    if (!editMode) {
                                        e.preventDefault();
                                        setEditMode(true);
                                    } else {
                                        handleSubmit(e);
                                    }
                                    }}
                                >
                                    {editMode ? "Save" : "Edit"}
                                </Button>
                            </Col>
                          </Row>

                          {/* <Button className="edit-btn" type={editMode ? "submit" : "button"} onClick={editMode ? handleSubmit : () => setEditMode(true)}>
                                                        {editMode ? 'Save' : 'Edit'}
                                                    </Button> */}

                        </Form>
                      )}
                    </Formik>
                  </TabPane>

                  <TabPane tabId="2" className="p-2">
                    <p className="fs-5">Personal details</p>
                    <div className="mt-3 d-flex justify-content-between align-items-center">
                      <span className="fs-5">Personal info</span>
                      <FiEdit2
                        className="cursor-pointer edit-btn-profile"
                        onClick={() => handleEditTab("personalDetail")}
                      />
                    </div>
                    <div className="mt-2">
                      <Row className="px-0 py-2">
                        <Col className="mt-1" xs={12}>
                          <span className="profile-heading">Gender</span>
                          <div>
                            {userData.gender ? (
                              <p className="mt-1">{userData.gender}</p>
                            ) : (
                              <span
                                className="text-primary cursor-pointer"
                                onClick={() => handleEditTab("personalDetail")}
                              >
                                Add gender
                              </span>
                            )}
                          </div>
                        </Col>

                        <Col className="mt-3" xs={12}>
                          <span className="profile-heading">
                            Martial Status
                          </span>
                          <div>
                            {userData.maritalStatus ? (
                              <p className="mt-1">{userData.maritalStatus}</p>
                            ) : (
                              <span
                                className="text-primary cursor-pointer"
                                onClick={() => handleEditTab("personalDetail")}
                              >
                                Add martial status
                              </span>
                            )}
                          </div>
                        </Col>

                        <Col className="mt-3" xs={12}>
                          <span className="profile-heading">Date of birth</span>
                          <div>
                            {userData.dateOfBirth ? (
                              <p className="mt-1">{userData.dateOfBirth}</p>
                            ) : (
                              <span
                                className="text-primary cursor-pointer"
                                onClick={() => handleEditTab("personalDetail")}
                              >
                                Add date of birth
                              </span>
                            )}
                          </div>
                        </Col>

                        <Col className="mt-3" xs={12}>
                          <p className="profile-heading">URL (LinkedIn)</p>
                          <div>
                            {userData.url ? (
                              <a
                                href={userData.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-1"
                              >
                                {userData.url}
                              </a>
                            ) : (
                              <span
                                className="text-primary cursor-pointer"
                                onClick={() => handleEditTab("personalDetail")}
                              >
                                Add URL
                              </span>
                            )}
                          </div>
                        </Col>
                      </Row>

                      <hr />

                      <div className="mt-1">
                        <div className="mb-2 d-flex justify-content-between">
                          <p className="fs-5">Education</p>
                          <p
                            className="text-primary cursor-pointer fw-bolder"
                            onClick={() => handleEditTab("personalDetail2")}
                          >
                            Add Education
                          </p>
                        </div>

                        {userData.educations?.length > 0 ? (
                          <>
                            {userData.educations.map((education, index) => (
                              <Row
                                className="mt-3 px-0 py-2 border border-secondary rounded"
                                key={education._id || index}
                              >
                                <Col className="mt-2" xs={12}>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span className="profile-heading">
                                      Education
                                    </span>
                                    <FaDeleteLeft
                                      className="fs-2 text-danger cursor-pointer"
                                      onClick={() =>
                                        handleDeleteField(
                                          "educations",
                                          education._id
                                        )
                                      }
                                    />
                                  </div>
                                  <p className="mt-1">{education.degree}</p>
                                </Col>

                                <Col className="mt-3" xs={12}>
                                  <span className="profile-heading">
                                    Institution
                                  </span>
                                  <p className="mt-1">
                                    {education.institution}
                                  </p>
                                </Col>

                                <Col xs={12} className="mt-3">
                                  <span className="profile-heading">
                                    {education.startDate !== null
                                      ? "Start date to Finish date"
                                      : "Finish date"}
                                  </span>
                                  <div className="d-flex align-items-center">
                                    <p className="mt-1">
                                      {education.startDate ? (
                                        <>
                                          {education?.startDate
                                            ? format(
                                                new Date(education.startDate),
                                                "yyyy-MM-dd"
                                              )
                                            : "Invalid Date"}{" "}
                                          <span className="mx-2 mt-1 profile-heading">
                                            to
                                          </span>{" "}
                                        </>
                                      ) : null}
                                    </p>
                                    <p className="mt-1">
                                      {education?.endDate
                                        ? format(
                                            new Date(education.endDate),
                                            "yyyy-MM-dd"
                                          )
                                        : "Inavlid Date"}
                                    </p>
                                  </div>
                                </Col>

                                <Col className="mt-3">
                                  <span className="profile-heading">
                                    Description
                                  </span>
                                  <div>
                                    <p className="mt-1">
                                      {education.description}
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </>
                        ) : (
                          <p
                            className="text-primary cursor-pointer"
                            onClick={() => handleEditTab("personalDetail2")}
                          >
                            Add education
                          </p>
                        )}
                      </div>

                      <hr />

                      <Row>
                        <Col className="mt-1" xs={12}>
                          <div className="d-flex justify-content-between">
                            <p className="fs-5">Languages</p>
                            <p
                              className="text-primary cursor-pointer fw-bolder"
                              onClick={() => handleEditTab("personalDetail2")}
                            >
                              Add Language
                            </p>
                          </div>
                          <Table responsive className="mt-3">
                            <thead>
                              <tr>
                                <td className="ps-0">
                                  <span className="profile-heading">
                                    Languages
                                  </span>
                                </td>
                                <td className="ps-0">
                                  <span className="profile-heading">
                                    Proficiency
                                  </span>
                                </td>
                                <td className="ps-0">
                                  <span className="profile-heading">Read</span>
                                </td>
                                <td className="ps-0">
                                  <span className="profile-heading">Write</span>
                                </td>
                                <td className="ps-0">
                                  <span className="profile-heading">Speek</span>
                                </td>
                                <td></td>
                              </tr>
                            </thead>
                            <tbody>
                              {userData.languages?.length > 0 ? (
                                <>
                                  {userData.languages.map((language, index) => (
                                    <tr key={language._id || index}>
                                      <td className="ps-0">
                                        {language.languageTitle}
                                      </td>
                                      <td className="ps-0">
                                        {language.expertLevel}
                                      </td>
                                      <td className="ps-0">
                                        {language.skills?.includes("Read") ? (
                                          <PiCheckCircleLight className="fs-4" />
                                        ) : (
                                          <PiXCircleLight className="fs-4" />
                                        )}
                                      </td>
                                      <td className="ps-0">
                                        {language.skills?.includes("Write") ? (
                                          <PiCheckCircleLight className="fs-4" />
                                        ) : (
                                          <PiXCircleLight className="fs-4" />
                                        )}
                                      </td>
                                      <td className="ps-0">
                                        {language.skills?.includes("Speak") ? (
                                          <PiCheckCircleLight className="fs-4" />
                                        ) : (
                                          <PiXCircleLight className="fs-4" />
                                        )}
                                      </td>
                                      <td className="px-0 py-1">
                                        <FaDeleteLeft
                                          className="m-0 fs-2 text-danger cursor-pointer"
                                          onClick={() =>
                                            handleDeleteField(
                                              "languages",
                                              language._id
                                            )
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              ) : (
                                <tr>
                                  <td colSpan="5" className="ps-0 text-primary">
                                    <span
                                      className="cursor-pointer"
                                      onClick={() =>
                                        handleEditTab("personalDetail2")
                                      }
                                    >
                                      Add language
                                    </span>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>

                      <hr />

                      <div className="mb-2 d-flex justify-content-between">
                        <p className="fs-5">Career break</p>
                        <p
                          className="text-primary cursor-pointer fw-bolder"
                          onClick={() => handleEditTab("personalDetail2")}
                        >
                          Add Career break
                        </p>
                      </div>

                      {userData.careerBreaks?.length > 0 ? (
                        <>
                          {userData.careerBreaks.map((career, index) => (
                            <Row
                              className="mt-3 px-0 py-2 border border-secondary rounded"
                              key={career._id || index}
                            >
                              <Col className="mt-2" xs={12}>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span className="profile-heading">
                                    Reason
                                  </span>
                                  <FaDeleteLeft
                                    className="fs-2 text-danger cursor-pointer"
                                    onClick={() =>
                                      handleDeleteField(
                                        "careerBreaks",
                                        career._id
                                      )
                                    }
                                  />
                                </div>
                                <p className="mt-1">{career.reason}</p>
                              </Col>

                              <Col className="mt-3" xs={12}>
                                <span className="profile-heading">
                                  Start date
                                </span>
                                <p className="mt-1">
                                  {career?.startDate
                                    ? format(
                                        new Date(career.startDate),
                                        "yyyy-MM-dd"
                                      )
                                    : "Invalid Date"}
                                </p>
                              </Col>

                              <Col className="mt-3" xs={12}>
                                <span className="profile-heading">
                                  End date
                                </span>
                                <div className="mt-1">
                                  <p>
                                    {career?.endDate
                                      ? format(
                                          new Date(career.endDate),
                                          "yyyy-MM-dd"
                                        )
                                      : "Invalid Date"}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          ))}
                        </>
                      ) : (
                        <p
                          className="text-primary cursor-pointer"
                          onClick={() => handleEditTab("personalDetail2")}
                        >
                          Add career break
                        </p>
                      )}

                      <hr />
                    </div>
                  </TabPane>

                  <TabPane tabId="3" className="p-2">
                    <span className="fs-5">Skills</span>
                    <FiEdit2
                      className="ms-3 mb-2 cursor-pointer edit-btn-profile"
                      onClick={() => handleEditTab("skills")}
                    />

                    <Row className="mb-4">
                      <Col>
                        <div className="mt-3 d-flex justify-content-between">
                          <p className="fs-5">Technical Skills</p>
                          <p
                            className="text-primary fw-bolder cursor-pointer"
                            onClick={() => handleEditTab("skills")}
                          >
                            Add Technical skills
                          </p>
                        </div>

                        {userData.skills.length > 0 ? (
                          <Row className="mt-3 ms-0">
                            {userData.skills.map((skill, index) => (
                              <Col
                                xs={6}
                                sm={4}
                                md={3}
                                lg={4}
                                className="p-0"
                                key={skill._id || index}
                              >
                                <div className="skills my-1 me-2 bg-light d-flex justify-content-between align-items-center border border-secondary">
                                  <div className="d-flex align-items-center">
                                    <span className="p-0 d-inline-block text-truncate skills-name">
                                      {skill.name}
                                    </span>
                                  </div>
                                  <RxCross2
                                    className="p-0 fs-5 cursor-pointer text-danger"
                                    onClick={() =>
                                      handleDeleteField("skill", skill._id)
                                    }
                                  />
                                </div>
                              </Col>
                            ))}
                          </Row>
                        ) : (
                          <p
                            className="text-primary cursor-pointer"
                            onClick={() => handleEditTab("skills")}
                          >
                            Add technical skills
                          </p>
                        )}
                      </Col>
                    </Row>

                    <hr />

                    <Row>
                      <Col className="mt-3" xs={12}>
                        <div className="d-flex justify-content-between">
                          <p className="fs-5">Certifications</p>
                          <p
                            className="text-primary cursor-pointer fw-bolder"
                            onClick={() => handleEditTab("skills")}
                          >
                            Add Certifications
                          </p>
                        </div>

                        {userData.certificates.length > 0 ? (
                          <>
                            {userData.certificates.map((certificate, index) => (
                              <Row
                                className="mt-3 px-0 py-2 border border-secondary rounded"
                                key={certificate._id || index}
                              >
                                <Col className="mt-2" xs={12}>
                                  <div className="d-flex justify-content-between">
                                    <span className="profile-heading">
                                      Certification name
                                    </span>
                                    <FaDeleteLeft
                                      className="fs-2 text-danger cursor-pointer"
                                      onClick={() =>
                                        handleDeleteField(
                                          "certificates",
                                          certificate._id
                                        )
                                      }
                                    />
                                  </div>
                                  <div>
                                    <p className="text-dark">
                                      {certificate.name}
                                    </p>
                                  </div>
                                </Col>

                                <Col className="mt-3" xs={12}>
                                  <span className="profile-heading">
                                    Certification issue date
                                  </span>
                                  <div className="mt-1">
                                    <p>
                                      {certificate?.issueDate
                                        ? format(
                                            new Date(certificate.issueDate),
                                            "yyyy-MM-dd"
                                          )
                                        : "Invalid Date"}
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                            ))}{" "}
                          </>
                        ) : (
                          <span
                            className="text-primary cursor-pointer"
                            onClick={() => handleEditTab("skills")}
                          >
                            Add certifications
                          </span>
                        )}
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="4">
                    <p className="fs-5">Resume</p>
                    <Row className="mt-4 px-1">
                      <Col className="d-flex align-items-center">
                        <span>
                          {userData.resumePath
                            ? `${userData.firstName} ${userData.lastName}.pdf`
                            : "No file here"}
                        </span>
                      </Col>

                      <Col className="d-flex justify-content-end">
                        <div className="d-flex">
                          <div className="resume-icon-div me-3">
                            <BiDownload
                              className="text-primary"
                              onClick={() =>
                                downloadFile(
                                  `${url.IMAGE_HOST_URL}${userData?.resumePath}`,
                                  `${
                                    userData?.firstName || "candidate"
                                  }_resume.pdf`
                                )
                              }
                            />
                          </div>

                          {/* <div className="resume-icon-div">
                                                        <RiDeleteBinLine className="text-primary" />
                                                    </div> */}
                        </div>
                      </Col>
                    </Row>
                    <Formik
                      initialValues={{
                        jobSeekerResume: userData.jobSeekerResume,
                      }}
                      onSubmit={handleSubmitResume}
                    >
                      {({ setFieldValue, isSubmitting }) => (
                        <Form>
                          <div className="my-2 mx-1 resume-border cursor-pointer">
                            <label
                              htmlFor="fileUpload"
                              className="mb-2 d-flex justify-content-center"
                            >
                              <Button
                                className="rounded-pill bg-transparent text-primary border border-primary cursor-pointer"
                                onClick={() =>
                                  document.getElementById("fileUpload").click()
                                }
                              >
                                <>
                                  <input
                                    id="fileUpload"
                                    type="file"
                                    style={{ display: "none" }}
                                    // onChange={handleFileChange}
                                    onChange={(event) => {
                                      const file = event.target.files[0];
                                      setFieldValue("jobSeekerResume", file);
                                      if (file) setFileName(file.name);
                                    }}
                                  />
                                  Update resume
                                </>
                              </Button>
                            </label>
                            {fileName === "" ? null : (
                              <p className="text-center">{fileName}</p>
                            )}
                            <p className="mt-2 text-secondary text-center">
                              Accepted file types are PDF, DOCX, RTF or TXT.
                            </p>
                          </div>

                          <div className="mt-5 d-flex justify-content-end">
                            <Button
                              type="submit"
                              className="edit-btn"
                              disabled={isSubmitting}
                            >
                              Submit Resume
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </TabPane>

                  <TabPane tabId="5" className="p-2">
                    <div className="mb-2 d-flex justify-content-between">
                      <div>
                        <span className="fs-5">Experiance</span>
                        {/* <FiEdit2 className="ms-3 mb-2 cursor-pointer edit-btn-profile" onClick={() => handleEditTab("experiance")} /> */}
                      </div>
                      <div className="d-flex justify-content-between">
                        <p
                          className="text-primary cursor-pointer fw-bolder"
                          onClick={() => handleEditTab("experiance")}
                        >
                          Add Experiance
                        </p>
                      </div>
                    </div>

                    <div className="mt-2">
                      {userData.experiences?.length > 0 ? (
                        <>
                          {userData.experiences.map((experiance, index) => (
                            <Row
                              className="mt-4 px-0 py-2 border border-secondary rounded"
                              key={experiance._id || index}
                            >
                              <Col className="mt-2" xs={12}>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span className="profile-heading">
                                    Company name
                                  </span>
                                  <FaDeleteLeft
                                    className="fs-2 text-danger cursor-pointer"
                                    onClick={() =>
                                      handleDeleteField(
                                        "experiences",
                                        experiance._id
                                      )
                                    }
                                  />
                                </div>
                                <p>{experiance.companyName}</p>
                              </Col>

                              <Col className="mt-3" xs={12}>
                                <span className="profile-heading">
                                  Job title
                                </span>
                                <p>{experiance.jobTitle}</p>
                              </Col>

                              <Col className="mt-3" xs={12}>
                                <span className="profile-heading">
                                  Duration
                                </span>
                                <p>{experiance.duration}</p>
                              </Col>

                              <Col className="mt-3" xs={12}>
                                <span className="profile-heading">Summary</span>
                                <div className="mt-1">
                                  <p>{experiance.summary}</p>
                                </div>
                              </Col>
                            </Row>
                          ))}
                        </>
                      ) : (
                        <p
                          className="text-primary cursor-pointer"
                          onClick={() => handleEditTab("experiance")}
                        >
                          Add experiance
                        </p>
                      )}
                    </div>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        size="lg"
        show={showPopup}
        onHide={() => setShowPopup(false)}
        backdrop="static"
        aria-labelledby="example-modal-sizes-title-lg"
        className="m-0 p-0"
      >
        <Modal.Header
          closeButton
          className="popup-header m-0 px-3 px-md-5 pt-4 pb-2"
        >
          <Modal.Title>Modal title</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-3 px-md-5 pb-4 pb-md-5 pt-1">
          {editTab === "skills" ? (
            <div>
              <p className="fs-5">Skills</p>
              <p className="profile-page-text">
                Mention skills like programming languages (Java, Python),
                softwares (Microsoft Word, Excel) and more, to show your
                technical expertise.
              </p>
              <div>
                <Formik
                  initialValues={{
                    skillName: "",
                    proficiency: "Beginner",
                    certificates: [
                      {
                        name: "",
                        issueDate: "",
                      },
                    ],
                  }}
                  validationSchema={validationSchemaSkills}
                  // onSubmit={handleSubmitSkills}
                  onSubmit={(values, actions) =>
                    handleSubmitForm(values, actions)
                  }
                >
                  {({
                    values,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    touched,
                    errors,
                    resetForm,
                    isSubmitting,
                  }) => (
                    <Form>
                      <Row className="mt-4">
                        <Col md={12}>
                          <div className="form-group">
                            <label htmlFor="skillName">Skill Name</label>
                            <Field
                              type="text"
                              name="skillName"
                              id="skillName"
                              className="BootstrapForms mt-2"
                              placeholder="Enter skill name"
                            />
                            <ErrorMessage
                              name="skillName"
                              component="div"
                              className="text-danger error-text"
                            />
                          </div>

                          <div className="form-group mt-4 mb-2">
                            <label htmlFor="proficiency">Proficiency</label>
                            <Field
                              as="select"
                              name="proficiency"
                              id="proficiency"
                              className="form-control mt-2"
                            >
                              <option value="Beginner">Beginner</option>
                              <option value="Intermediate">Intermediate</option>
                              <option value="Expert">Expert</option>
                              <option value="Advanced">Advanced</option>
                            </Field>
                            <ErrorMessage
                              name="proficiency"
                              component="div"
                              className="text-danger error-text"
                            />
                          </div>

                          {skillError === "" ? null : (
                            <p className="mt-2 text-danger">{skillError}</p>
                          )}

                          <div className="d-flex justify-content-end">
                            <button
                              type="button"
                              className="btn btn-primary mt-4"
                              onClick={() =>
                                handleAddSkill(values, setFieldValue, resetForm)
                              }
                              disabled={isSubmitting}
                            >
                              Add Skill
                            </button>
                          </div>

                          {userData.skills.length > 0 && (
                            <Row className="mt-4 mb-3">
                              <Col xs={12}>
                                <p className="fs-5 ms-0 mb-2">Added Skills:</p>
                              </Col>
                              {userData.skills.map((skill, index) => (
                                <Col
                                  xs={6}
                                  sm={4}
                                  md={4}
                                  lg={3}
                                  className="px-1"
                                  // className="BootstrapForms my-1 mx-2 bg-light d-flex justify-content-between align-items-center border border-secondary"
                                  key={skill._id}
                                >
                                  <div className="skills my-1 me-2 bg-light d-flex justify-content-between align-items-center border border-secondary">
                                    <div className="d-flex align-items-center">
                                      <span className="p-0 d-inline-block text-truncate skills-name-popup">
                                        {skill.name}
                                      </span>
                                    </div>
                                    <RxCross2
                                      className="p-0 fs-5 cursor-pointer text-danger"
                                      onClick={() =>
                                        handleDeleteField("skill", skill._id)
                                      }
                                    />
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          )}
                        </Col>
                      </Row>

                      <hr />

                      <Row className="mt-4">
                        <Col xs={12}>
                          <label className="fs-5">Certifications</label>
                        </Col>

                        <FieldArray
                          name="certificates"
                          render={(arrayHelpers) => (
                            <>
                              {values.certificates.map((certificate, index) => (
                                <div key={index}>
                                  <Col xs={12} className="mt-4">
                                    <label>Certification Name</label>
                                    <Field
                                      type="text"
                                      name={`certificates[${index}].name`}
                                      className="BootstrapForms mt-2"
                                      placeholder="Certification name"
                                    />
                                    <ErrorMessage
                                      name={`certificates[${index}].name`}
                                      component="div"
                                      className="text-danger error-text"
                                    />
                                  </Col>

                                  <Col xs={12} className="my-4">
                                    <label>Issue Date</label>
                                    <Field
                                      type="date"
                                      name={`certificates[${index}].issueDate`}
                                      className="BootstrapForms mt-2"
                                    />
                                    <ErrorMessage
                                      name={`certificates[${index}].issueDate`}
                                      component="div"
                                      className="text-danger error-text"
                                    />
                                  </Col>

                                  {values.certificates.length > 1 && (
                                    <Col
                                      sm={12}
                                      className="mt-4 d-flex justify-content-end"
                                    >
                                      <p
                                        // type="button"
                                        // className="btn btn-danger py-1"
                                        onClick={() =>
                                          arrayHelpers.remove(index)
                                        }
                                        className="cursor-pointer text-danger fw-bold d-inline-block"
                                      >
                                        Remove
                                      </p>
                                    </Col>
                                  )}
                                </div>
                              ))}

                              <Col xs={12} className="mt-3">
                                {values.certificates.length < 4 && (
                                  <p
                                    // type="button"
                                    // className="btn btn-success"
                                    className="cursor-pointer text-primary fw-bold d-inline-block"
                                    onClick={() =>
                                      arrayHelpers.push({
                                        name: "",
                                        issueDate: "",
                                      })
                                    }
                                  >
                                    Add another certification
                                  </p>
                                )}
                              </Col>
                            </>
                          )}
                        />
                      </Row>

                      <div className="mt-4 d-flex justify-content-end align-items-center">
                        <Link
                          as="Button"
                          varient="primary"
                          className="cancel-btn me-3"
                          onClick={() => setShowPopup(false)}
                        >
                          Cancel
                        </Link>
                        <Button
                          type="submit"
                          variant="primary"
                          className="rounded-pill px-3"
                        >
                          Save
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          ) : editTab === "personalDetail" ? (
            <div>
              <p className="fs-5">Personal details</p>
              <p className="profile-page-text">
                This information is important for employers to know you better
              </p>
              <Formik
                initialValues={{
                  gender: userData.gender || "",
                  maritalStatus: userData.maritalStatus || "",
                  dateOfBirth: userData.dateOfBirth || "",
                  url: userData.url || "",
                }}
                validationSchema={validationSchemaDetails}
                onSubmit={handleSubmitDetail}
              >
                {({
                  errors,
                  values,
                  setFieldValue,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <Form>
                    <Row>
                      <Col sm={12} className="mt-4 mb-2">
                        <BootstrapForm.Group controlId="formBasicEmail">
                          <BootstrapForm.Label>
                            Gender <span className="text-danger">*</span>
                          </BootstrapForm.Label>
                          <Select
                            className="w-100"
                            name="gender"
                            value={
                              values.gender
                                ? {
                                    value: values.gender,
                                    label:
                                      values.gender.charAt(0).toUpperCase() +
                                      values.gender.slice(1),
                                  }
                                : null
                            }
                            onChange={(selectedOption) =>
                              setFieldValue(
                                "gender",
                                selectedOption ? selectedOption.value : ""
                              )
                            }
                            options={[
                              { value: "Male", label: "Male" },
                              { value: "Female", label: "Female" },
                              { value: "Other", label: "Other" },
                            ]}
                            placeholder="Gender"
                            isSearchable={false}
                            isClearable
                            components={{ IndicatorSeparator: () => null }}
                            styles={customStyles}
                          />
                        </BootstrapForm.Group>
                        {touched.gender && errors.gender && (
                          <div className="text-danger error-text">
                            {errors.gender}
                          </div>
                        )}
                      </Col>

                      <Col sm={12} className="mt-4 mb-2">
                        <BootstrapForm.Group controlId="formBasicEmail">
                          <BootstrapForm.Label>
                            Date of Birth <span className="text-danger">*</span>
                          </BootstrapForm.Label>
                          <BootstrapForm.Control
                            type="date"
                            name="dateOfBirth"
                            value={values.dateOfBirth}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="BootstrapForms"
                          />
                          {touched.dateOfBirth && errors.dateOfBirth && (
                            <div className="text-danger error-text">
                              {errors.dateOfBirth}
                            </div>
                          )}
                        </BootstrapForm.Group>
                      </Col>

                      <Col sm={12} className="mt-4 mb-3">
                        <BootstrapForm.Group controlId="formBasicEmail">
                          <BootstrapForm.Label>
                            Marital Status{" "}
                            <span className="text-danger">*</span>
                          </BootstrapForm.Label>
                          <Select
                            className="w-100"
                            name="maritalStatus"
                            value={
                              values.maritalStatus
                                ? {
                                    value: values.maritalStatus,
                                    label:
                                      values.maritalStatus
                                        .charAt(0)
                                        .toUpperCase() +
                                      values.maritalStatus.slice(1),
                                  }
                                : null
                            }
                            onChange={(selectedOption) =>
                              setFieldValue(
                                "maritalStatus",
                                selectedOption ? selectedOption.value : ""
                              )
                            }
                            options={[
                              { value: "Married", label: "Married" },
                              { value: "Unmarried", label: "Unmarried" },
                              { value: "Others", label: "Others" },
                            ]}
                            placeholder="Marital Status"
                            isSearchable={false}
                            isClearable
                            components={{ IndicatorSeparator: () => null }}
                            styles={customStyles}
                          />
                        </BootstrapForm.Group>
                        {touched.maritalStatus && errors.maritalStatus && (
                          <div className="text-danger error-text">
                            {errors.maritalStatus}
                          </div>
                        )}
                      </Col>

                      <Col sm={12} className="mt-4 mb-3">
                        <BootstrapForm.Group>
                          <BootstrapForm.Label>
                            Website URL (LinkedIn)
                          </BootstrapForm.Label>
                          <BootstrapForm.Control
                            type="url"
                            name="url"
                            value={values.url}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="BootstrapForms"
                            placeholder="https://example.com"
                          />
                          {touched.url && errors.url && (
                            <div className="text-danger error-text">
                              {errors.url}
                            </div>
                          )}
                        </BootstrapForm.Group>
                      </Col>
                    </Row>

                    <div className="mt-4 d-flex justify-content-end align-items-center">
                      <Link
                        as="Button"
                        varient="primary"
                        className="cancel-btn me-3"
                        onClick={() => setShowPopup(false)}
                      >
                        Cancel
                      </Link>
                      <Button
                        type="submit"
                        variant="primary"
                        className="rounded-pill px-3"
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          ) : editTab === "personalDetail2" ? (
            <div>
              <p className="fs-5">Personal details</p>
              <p className="profile-page-text">
                This information is important for employers to know you better
              </p>
              <Formik
                initialValues={{
                  careerBreak: [
                    {
                      reason: "",
                      startDate: "",
                      endDate: "",
                    },
                  ],
                  educations: [
                    {
                      degree: "",
                      institution: "",
                      startDate: "",
                      endDate: "",
                      description: "",
                    },
                  ],
                  languages: [
                    {
                      languageTitle: "",
                      expertLevel: "",
                      skills: [],
                    },
                  ],
                }}
                validationSchema={validationSchemaDetails2}
                onSubmit={handleSubmitDetail2}
              >
                {({
                  errors,
                  values,
                  setFieldValue,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <Form>
                    <Row>
                      <Col xs={12} className="mt-4">
                        <BootstrapForm.Label className="fs-5">
                          Education Detail
                        </BootstrapForm.Label>
                      </Col>

                      <FieldArray name="educations">
                        {({ push, remove }) => (
                          <>
                            {values.educations.map((_, index) => (
                              <Row key={index} className="mb-4">
                                <Col sm={6} className="mt-4">
                                  <BootstrapForm.Group
                                    controlId={`educations.${index}.degree`}
                                  >
                                    <BootstrapForm.Label>
                                      Education
                                    </BootstrapForm.Label>
                                    <Select
                                      className="w-100"
                                      name={`educations.${index}.degree`}
                                      value={
                                        values.educations[index].degree
                                          ? {
                                              value:
                                                values.educations[index].degree,
                                              label:
                                                values.educations[index].degree,
                                            }
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        setFieldValue(
                                          `educations.${index}.degree`,
                                          selectedOption
                                            ? selectedOption.value
                                            : ""
                                        )
                                      }
                                      options={[
                                        {
                                          value:
                                            "B.E Computer Science Engineering",
                                          label:
                                            "B.E Computer Science Engineering",
                                        },
                                        {
                                          value:
                                            "B.E Electrical and Electronic Engineering",
                                          label:
                                            "B.E Electrical and Electronic Engineering",
                                        },
                                        {
                                          value: "B.E Mechanical Engineering",
                                          label: "B.E Mechanical Engineering",
                                        },
                                        {
                                          value: "B.Sc Computer Science",
                                          label: "B.Sc Computer Science",
                                        },
                                        {
                                          value: "B.Sc Physics",
                                          label: "B.Sc Physics",
                                        },
                                        {
                                          value: "B.Sc Chemistry",
                                          label: "B.Sc Chemistry",
                                        },
                                        {
                                          value: "B.Sc Maths",
                                          label: "B.Sc Maths",
                                        },
                                        { value: "12th", label: "12th" },
                                        { value: "10th", label: "10th" },
                                        {
                                          value: "ITI Certification",
                                          label: "ITI Certification",
                                        },
                                        {
                                          value: "Other Graduate",
                                          label: "Other Graduate",
                                        },

                                        // { value: "Bachelor's Degree", label: "Bachelor's Degree" },
                                        // { value: "Master's Degree", label: "Master's Degree" },
                                        // { value: "Professional Degree", label: "Professional Degree" },
                                        // { value: "Associate Degree", label: "Associate Degree" },
                                        // { value: "Doctorate (PhD)", label: "Doctorate (PhD)" },
                                        // { value: "Diploma", label: "Diploma" },
                                        // { value: "High School", label: "High School" },
                                        // { value: "Middle School", label: "Middle School" },
                                        // { value: "Vocational Training", label: "Vocational Training" },
                                        // { value: "Postdoctoral Studies", label: "Postdoctoral Studies" },
                                        // { value: "No Formal Education", label: "No Formal Education" },
                                        // { value: "Some College, No Degree", label: "Some College, No Degree" },
                                        // { value: "GED (General Educational Development)", label: "GED (General Educational Development)" },
                                        // { value: "Technical School", label: "Technical School" },
                                        // { value: "Trade School", label: "Trade School" },
                                      ]}
                                      placeholder="Education"
                                      isSearchable
                                      isClearable
                                      styles={customStyles}
                                      components={{
                                        IndicatorSeparator: () => null,
                                      }}
                                    />
                                    {touched.educations?.[index]?.degree &&
                                      errors.educations?.[index]?.degree && (
                                        <div className="error-text text-danger">
                                          {
                                            errors.educations[index].degree
                                              .label
                                          }
                                        </div>
                                      )}
                                  </BootstrapForm.Group>
                                </Col>

                                <Col sm={6} className="mt-4">
                                  <BootstrapForm.Group
                                    controlId={`educations.${index}.institution`}
                                  >
                                    <BootstrapForm.Label>
                                      Institution
                                    </BootstrapForm.Label>
                                    <BootstrapForm.Control
                                      type="text"
                                      name={`educations.${index}.institution`}
                                      value={
                                        values.educations[index].institution
                                      }
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      className="BootstrapForms"
                                      placeholder="Institution"
                                    />
                                    {touched.educations?.[index]?.institution &&
                                      errors.educations?.[index]
                                        ?.institution && (
                                        <div className="error-text text-danger">
                                          {errors.educations[index].institution}
                                        </div>
                                      )}
                                  </BootstrapForm.Group>
                                </Col>

                                {values.educations[index].degree !== "12th" &&
                                  values.educations[index].degree !==
                                    "10th" && (
                                    <Col sm={6} className="mt-4">
                                      <BootstrapForm.Group
                                        controlId={`educations.${index}.startDate`}
                                      >
                                        <BootstrapForm.Label>
                                          Start Year
                                        </BootstrapForm.Label>
                                        <BootstrapForm.Control
                                          type="date"
                                          name={`educations.${index}.startDate`}
                                          value={
                                            values.educations[index].startDate
                                          }
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          className="BootstrapForms"
                                        />
                                        {touched.educations?.[index]
                                          ?.startDate &&
                                          errors.educations?.[index]
                                            ?.startDate && (
                                            <div className="text-danger error-text">
                                              {
                                                errors.educations[index]
                                                  .startDate
                                              }
                                            </div>
                                          )}
                                      </BootstrapForm.Group>
                                    </Col>
                                  )}

                                <Col sm={6} className="mt-4">
                                  <BootstrapForm.Group
                                    controlId={`educations.${index}.endDate`}
                                  >
                                    <BootstrapForm.Label>
                                      Finish Year
                                    </BootstrapForm.Label>
                                    <BootstrapForm.Control
                                      type="date"
                                      name={`educations.${index}.endDate`}
                                      value={values.educations[index].endDate}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      className="BootstrapForms"
                                    />
                                    {touched.educations?.[index]?.endDate &&
                                      errors.educations?.[index]?.endDate && (
                                        <div className="text-danger error-text">
                                          {errors.educations[index].endDate}
                                        </div>
                                      )}
                                  </BootstrapForm.Group>
                                </Col>

                                <Col xs={12} className="mt-4">
                                  <BootstrapForm.Label>
                                    Description
                                  </BootstrapForm.Label>
                                  <Field
                                    as="textarea"
                                    name={`educations.${index}.description`}
                                    id={`educations.${index}.description`}
                                    rows="3"
                                    className="form-control"
                                    placeholder="Enter a Description"
                                  />
                                  <ErrorMessage
                                    name={`educations.${index}.description`}
                                    component="div"
                                    className="error-text text-danger"
                                  />
                                </Col>

                                <Col
                                  sm={12}
                                  className="mt-4 d-flex justify-content-end"
                                >
                                  {values.educations.length > 1 && (
                                    <p
                                      // type="button"
                                      // variant="danger"
                                      // className="py-1"
                                      className="cursor-pointer text-danger fw-bold d-inline-block"
                                      onClick={() => remove(index)}
                                    >
                                      Remove
                                    </p>
                                  )}
                                </Col>
                              </Row>
                            ))}

                            <div sm={12} className="mb-3">
                              {values.educations.length < 4 && (
                                <p
                                  // variant="success"
                                  onClick={() =>
                                    push({
                                      degree: "",
                                      institution: "",
                                      startDate: "",
                                      endDate: "",
                                      description: "",
                                    })
                                  }
                                  className="mt-3 cursor-pointer text-primary fw-bold d-inline-block"
                                >
                                  Add another education
                                </p>
                              )}
                            </div>
                          </>
                        )}
                      </FieldArray>
                    </Row>

                    <hr />

                    <Row>
                      <Col xs={12} className="mt-2">
                        <BootstrapForm.Label className="fs-5">
                          Languages
                        </BootstrapForm.Label>
                      </Col>
                      <FieldArray name="languages">
                        {({ push, remove }) => (
                          <>
                            {values.languages.map((_, index) => (
                              <div key={index} className="mb-4">
                                <Row>
                                  <Col sm={6} className="mt-4">
                                    <BootstrapForm.Group
                                      controlId={`languages.${index}.languageTitle`}
                                    >
                                      <BootstrapForm.Label>
                                        Language
                                      </BootstrapForm.Label>
                                      <Field
                                        type="text"
                                        name={`languages.${index}.languageTitle`}
                                        className="BootstrapForms"
                                        placeholder="Language"
                                      />
                                      <ErrorMessage
                                        name={`languages.${index}.languageTitle`}
                                        component="div"
                                        className="error-text text-danger"
                                      />
                                    </BootstrapForm.Group>
                                  </Col>

                                  <Col sm={6} className="mt-4">
                                    <BootstrapForm.Group
                                      controlId={`languages.${index}.expertLevel`}
                                    >
                                      <BootstrapForm.Label>
                                        Proficiency
                                      </BootstrapForm.Label>
                                      <Select
                                        className="w-100"
                                        name={`languages.${index}.expertLevel`}
                                        // value={values.languages[index].proficiency}
                                        // onChange={(selectedOption) =>
                                        //     setFieldValue(`languages.${index}.proficiency`, selectedOption.values)
                                        // }
                                        value={
                                          values.languages[index].expertLevel
                                            ? {
                                                value:
                                                  values.languages[index]
                                                    .expertLevel,
                                                label:
                                                  values.languages[index]
                                                    .expertLevel,
                                              }
                                            : null
                                        }
                                        onChange={
                                          (selectedOption) =>
                                            setFieldValue(
                                              `languages.${index}.expertLevel`,
                                              selectedOption
                                                ? selectedOption.value
                                                : ""
                                            ) // Update the Formik value
                                        }
                                        options={[
                                          {
                                            value: "Beginner",
                                            label: "Beginner",
                                          },
                                          {
                                            value: "Proficient",
                                            label: "Proficient",
                                          },
                                          { value: "Expert", label: "Expert" },
                                        ]}
                                        placeholder="Expert Level"
                                        isSearchable={false}
                                        isClearable
                                        styles={customStyles}
                                        components={{
                                          IndicatorSeparator: () => null,
                                        }}
                                      />
                                      <ErrorMessage
                                        name={`languages.${index}.expertLevel`}
                                        component="div"
                                        className="error-text text-danger"
                                      />
                                    </BootstrapForm.Group>
                                  </Col>

                                  <Col className="mt-3">
                                    <Row>
                                      {["Read", "Write", "Speak"].map(
                                        (skill) => (
                                          <Col sm={3} key={skill}>
                                            <div className="d-flex align-items-center">
                                              <BootstrapForm.Check
                                                type="checkbox"
                                                name={`languages.${index}.skills`}
                                                value={skill}
                                                onChange={(e) => {
                                                  const { checked } = e.target;
                                                  const skills =
                                                    values.languages[index]
                                                      .skills || [];
                                                  if (checked) {
                                                    setFieldValue(
                                                      `languages.${index}.skills`,
                                                      [...skills, skill]
                                                    );
                                                  } else {
                                                    setFieldValue(
                                                      `languages.${index}.skills`,
                                                      skills.filter(
                                                        (s) => s !== skill
                                                      )
                                                    );
                                                  }
                                                }}
                                                checked={values.languages[
                                                  index
                                                ].skills.includes(skill)}
                                                className="filter-checkbox"
                                              />
                                              <label
                                                htmlFor={`languages.${index}.skills`}
                                                className="filter-label"
                                              >
                                                {skill}
                                              </label>
                                            </div>
                                          </Col>
                                        )
                                      )}
                                    </Row>
                                    <ErrorMessage
                                      name={`languages.${index}.skills`}
                                      component="div"
                                      className="error-text text-danger"
                                    />
                                  </Col>
                                </Row>

                                <Col
                                  sm={12}
                                  className="mt-4 d-flex justify-content-end"
                                >
                                  {values.languages.length > 1 && (
                                    <p
                                      // type="button"
                                      // variant="danger"
                                      // className="py-1"
                                      className="cursor-pointer text-danger fw-bold d-inline-block"
                                      onClick={() => remove(index)}
                                    >
                                      Remove
                                    </p>
                                  )}
                                </Col>
                              </div>
                            ))}

                            <div sm={12} className="mb-3">
                              {values.languages.length < 4 && (
                                <p
                                  // type="button"
                                  // variant="success"
                                  className="mt-3 cursor-pointer text-primary fw-bold d-inline-block"
                                  onClick={() =>
                                    push({
                                      language: "",
                                      proficiency: "",
                                      skills: [],
                                    })
                                  }
                                >
                                  Add another language
                                </p>
                              )}
                            </div>
                          </>
                        )}
                      </FieldArray>
                    </Row>

                    <hr />

                    <Row>
                      <Col xs={12} className="mt-4">
                        <BootstrapForm.Label className="fs-5">
                          Career Break
                        </BootstrapForm.Label>
                      </Col>

                      <FieldArray name="careerBreak">
                        {({ remove, push }) => (
                          <>
                            {values.careerBreak.map((_, index) => (
                              <Row key={index} className="career-break-entry">
                                <Col sm={6} className="mt-3">
                                  <BootstrapForm.Group
                                    controlId={`careerBreak[${index}].startDate`}
                                  >
                                    <BootstrapForm.Label>
                                      Start Date
                                    </BootstrapForm.Label>
                                    <Field
                                      type="date"
                                      name={`careerBreak[${index}].startDate`}
                                      className="BootstrapForms"
                                    />
                                    <ErrorMessage
                                      name={`careerBreak[${index}].startDate`}
                                      component="div"
                                      className="error-text text-danger"
                                    />
                                  </BootstrapForm.Group>
                                </Col>

                                <Col sm={6} className="mt-3">
                                  <BootstrapForm.Group
                                    controlId={`careerBreak[${index}].endDate`}
                                  >
                                    <BootstrapForm.Label>
                                      End Date
                                    </BootstrapForm.Label>
                                    <Field
                                      type="date"
                                      name={`careerBreak[${index}].endDate`}
                                      className="BootstrapForms"
                                    />
                                    <ErrorMessage
                                      name={`careerBreak[${index}].endDate`}
                                      component="div"
                                      className="error-text text-danger"
                                    />
                                  </BootstrapForm.Group>
                                </Col>

                                <Col sm={12} className="my-3 mt-4">
                                  <BootstrapForm.Group
                                    controlId={`careerBreak[${index}].reason`}
                                  >
                                    <BootstrapForm.Label>
                                      Reason
                                    </BootstrapForm.Label>
                                    <Field
                                      as="textarea"
                                      rows="3"
                                      name={`careerBreak[${index}].reason`}
                                      className="form-control"
                                      placeholder="Reason for the career break"
                                    />
                                    <ErrorMessage
                                      name={`careerBreak[${index}].reason`}
                                      component="div"
                                      className="error-text text-danger"
                                    />
                                  </BootstrapForm.Group>
                                </Col>

                                <Col sm={12} className="mt-3 text-end">
                                  {values.careerBreak.length > 1 && (
                                    <p
                                      // type="button"
                                      className="cursor-pointer text-danger fw-bold d-inline-block"
                                      onClick={() => remove(index)}
                                    >
                                      Remove
                                    </p>
                                  )}
                                </Col>
                              </Row>
                            ))}

                            <Col sm={12} className="my-3">
                              {values.careerBreak.length < 4 && (
                                <p
                                  // type="button"
                                  className="cursor-pointer text-primary fw-bold d-inline-block"
                                  onClick={() =>
                                    push({
                                      reason: "",
                                      startDate: "",
                                      endDate: "",
                                    })
                                  }
                                >
                                  Add another career break
                                </p>
                              )}
                            </Col>
                          </>
                        )}
                      </FieldArray>
                    </Row>

                    <div className="mt-4 d-flex justify-content-end align-items-center">
                      <Link
                        as="Button"
                        varient="primary"
                        className="cancel-btn me-3"
                        onClick={() => setShowPopup(false)}
                      >
                        Cancel
                      </Link>
                      <Button
                        type="submit"
                        variant="primary"
                        className="rounded-pill px-3"
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          ) : (
            <div>
              <p className="fs-5">Experiance</p>
              <p className="profile-page-text">
                Details like job title, company name, etc, help employers
                understand your work
              </p>

              <Formik
                initialValues={{
                  experiances: [
                    {
                      companyName: "",
                      jobTitle: "",
                      summary: "",
                      duration: "",
                    },
                  ],
                }}
                validationSchema={validationSchemaExperiance}
                onSubmit={handleSubmitExperiance}
              >
                {({
                  values,
                  setFieldValue,
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                }) => (
                  <Form>
                    <FieldArray name="experiances">
                      {({ push, remove }) => (
                        <>
                          {values.experiances.map((_, index) => (
                            <Row key={index}>
                              <Col sm={12} className="mt-4">
                                <BootstrapForm.Group
                                  controlId={`experiances[${index}].companyName`}
                                >
                                  <BootstrapForm.Label>
                                    Company Name{" "}
                                    <span className="text-danger">*</span>
                                  </BootstrapForm.Label>
                                  <BootstrapForm.Control
                                    type="text"
                                    className="BootstrapForms"
                                    name={`experiances[${index}].companyName`}
                                    value={
                                      values.experiances[index]?.companyName
                                    } // Bind value here
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Company name"
                                  />
                                  {touched.experiances?.[index]?.companyName &&
                                    errors.experiances?.[index]
                                      ?.companyName && (
                                      <div className="error-text text-danger">
                                        {errors.experiances[index].companyName}
                                      </div>
                                    )}
                                </BootstrapForm.Group>
                              </Col>

                              <Col sm={12} className="mt-4">
                                <BootstrapForm.Group
                                  controlId={`experiances[${index}].jobTitle`}
                                >
                                  <BootstrapForm.Label>
                                    Job Title{" "}
                                    <span className="text-danger">*</span>
                                  </BootstrapForm.Label>
                                  <BootstrapForm.Control
                                    type="text"
                                    className="BootstrapForms"
                                    name={`experiances[${index}].jobTitle`}
                                    value={values.experiances[index]?.jobTitle} // Bind value here
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Job title"
                                  />
                                  {touched.experiances?.[index]?.jobTitle &&
                                    errors.experiances?.[index]?.jobTitle && (
                                      <div className="error-text text-danger">
                                        {errors.experiances[index].jobTitle}
                                      </div>
                                    )}
                                </BootstrapForm.Group>
                              </Col>

                              <Col sm={12} className="mt-4">
                                <BootstrapForm.Group
                                  controlId={`experiances[${index}].summary`}
                                >
                                  <BootstrapForm.Label>
                                    Summary{" "}
                                    <span className="text-danger">*</span>
                                  </BootstrapForm.Label>
                                  <Field
                                    as="textarea"
                                    rows="3"
                                    name={`experiances[${index}].summary`}
                                    value={values.experiances[index]?.summary} // Bind value here
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="form-control"
                                    placeholder="Enter a Experiance summary"
                                  />
                                  {touched.experiances?.[index]?.summary &&
                                    errors.experiances?.[index]?.summary && (
                                      <div className="error-text text-danger">
                                        {errors.experiances[index].summary}
                                      </div>
                                    )}
                                </BootstrapForm.Group>
                              </Col>

                              <Col sm={6} className="mt-4">
                                <BootstrapForm.Group
                                  controlId={`experiances.[${index}].duration`}
                                >
                                  <BootstrapForm.Label>
                                    Duration Year{" "}
                                    <span className="text-danger">*</span>
                                  </BootstrapForm.Label>
                                  <Select
                                    className="w-100"
                                    name={`experiances.${index}.duration`}
                                    value={
                                      values.experiances[index].duration
                                        ? {
                                            value:
                                              values.experiances[index]
                                                .duration,
                                            label:
                                              values.experiances[index]
                                                .duration,
                                          }
                                        : null
                                    }
                                    onChange={
                                      (selectedOption) =>
                                        setFieldValue(
                                          `experiances.${index}.duration`,
                                          selectedOption
                                            ? selectedOption.value
                                            : ""
                                        ) // Update Formik value
                                    }
                                    options={[
                                      { value: "1 Year", label: "1 Year" },
                                      { value: "2 Years", label: "2 Years" },
                                      { value: "3 Years", label: "3 Years" },
                                      { value: "4 Years", label: "4 Years" },
                                      { value: "5 Years", label: "5 Years" },
                                      { value: "6 Years", label: "6 Years" },
                                      { value: "7 Years", label: "7 Years" },
                                      { value: "8 Years", label: "8 Years" },
                                      { value: "9 Years", label: "9 Years" },
                                      { value: "10 Years", label: "10 Years" },
                                      {
                                        value: "10+ Years",
                                        label: "10+ Years",
                                      },
                                    ]}
                                    placeholder="Duration year"
                                    isSearchable
                                    isClearable
                                    styles={customStyles}
                                    components={{
                                      IndicatorSeparator: () => null,
                                    }}
                                  />
                                  {touched.experiances?.[index]?.duration &&
                                    errors.experiances?.[index]?.duration && (
                                      <div className="error-text text-danger">
                                        {errors.experiances[index].duration}
                                      </div>
                                    )}
                                </BootstrapForm.Group>
                              </Col>

                              <Col
                                sm={12}
                                className="mt-4 d-flex justify-content-end"
                              >
                                {values.experiances.length > 1 && (
                                  <p
                                    // type="button"
                                    // variant="danger"
                                    className="cursor-pointer text-danger fw-bold d-inline-block"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </p>
                                )}
                              </Col>
                            </Row>
                          ))}

                          <div sm={12} className="mt-4">
                            {values.experiances.length < 4 && (
                              <p
                                // type="button"
                                // variant="success"
                                className="cursor-pointer text-primary fw-bold d-inline-block"
                                onClick={() =>
                                  push({
                                    companyName: "",
                                    jobTitle: "",
                                    summary: "",
                                    duration: "",
                                  })
                                }
                              >
                                Add another experience
                              </p>
                            )}
                          </div>
                        </>
                      )}
                    </FieldArray>

                    <div className="mt-4 d-flex justify-content-end align-items-center">
                      <Link
                        as="Button"
                        varient="primary"
                        className="cancel-btn me-3"
                        onClick={() => setShowPopup(false)}
                      >
                        Cancel
                      </Link>
                      <Button
                        type="submit"
                        variant="primary"
                        className="rounded-pill px-3"
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default JobSeekerProfile;
